import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert2";
import { useSecureData } from "../hooks/isLogged";
import Loading from "../Components/Loading";

export default function Login() {
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMssg, setErrorMssg] = useState(null);
  const [logged, setLogged] = useState(false);
  const { data, loadData, error } = useSecureData(
    localStorage.getItem("token")
  );

  useEffect(() => {
    setLoading(true);
    if (data && !loadData && !error) {
      setLogged(true);
    }
    setLoading(false);
  }, [data, loadData, error]);

  const navigate = useNavigate();

  useEffect(() => {
    if (logged) {
      navigate("/");
    }
  });

  const handleLogin = async (e) => {
    e.preventDefault();

    setLoading(true);

    const data = { username, password };

    const response = await fetch(
      "https://kjpp-server.vercel.app/api/admin/login",
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const json = await response.json();

    if (!response.ok) {
      setLoading(false);
      setErrorMssg(json.mssg);
      return false;
    }

    localStorage.setItem("token", json.token);
    setLoading(false);

    swal
      .fire({
        title: "Login Success!",
        icon: "success",
        confirmButtonText: "Close",
        timer: 1000,
      })
      .then(() => {
        navigate("/");
      });
  };

  return (
    <div>
      {loading && (
        <div className="h-screen w-full flex justify-center items-center">
          <Loading />
        </div>
      )}
      {!loading && (
        <div className="h-screen w-full flex justify-center items-center">
          <form className="min-w-96">
            <h1 className="text-center text-2xl font-bold mb-5">
              Are you admin?
            </h1>

            <div className="mb-5">
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Your username
              </label>
              <input
                type="text"
                id="username"
                name="username"
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5"
                placeholder="Example..."
                required
              />
            </div>
            <div className="mb-5">
              <label
                htmlFor="password"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Your password
              </label>
              <input
                type="password"
                id="password"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5"
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                required
                placeholder="********"
              />
            </div>

            {errorMssg && (
              <div className="my-5 border-red-700 border rounded-md p-5">
                <h1 className="text-red-700">{errorMssg}</h1>
              </div>
            )}

            <button
              type="submit"
              className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
              onClick={handleLogin}
            >
              Login
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
